import React from 'react'
import { isShortcodeEnabledForNBWidgetFrenchStrings } from 'tools/helper'

export const isFrenchWidgetStringsEnabled: boolean = isShortcodeEnabledForNBWidgetFrenchStrings()

const FORM_LABEL_FR: Record<string, string> = {
  'Policy Number': 'Numéro de police',
  'Fleet Name': 'Nom de la flotte',
  'Your Email': 'Votre adresse courriel',
  'First Name': 'Prénom',
  'Last Name': 'Nom de famille',
}

export const WIDGET_STRINGS = {
  verifiedTitle: { en: 'Credentials Verified', fr: 'Identifiants vérifiés' },
  failedTitle: { en: 'Credentials Failed', fr: 'La vérification a échoué' },
  verifiedBody: (eld: string) => ({
    en: `Your ${eld} credentials have been verified.`,
    fr: `Vos identifiants ${eld} ont été vérifiés.`,
  }),
  failedBody: (eld: string) => ({
    en: `Your ${eld} credentials could not be verified. Please try again.`,
    fr: `Vos identifiants ${eld} n'ont pas pu être vérifiés. Veuillez essayer de nouveau.`,
  }),
  terms: {
    en: {
      prefix: (invitingCompanyName?: string | null) =>
        `By authorizing, you agree to ${
          invitingCompanyName ? `${invitingCompanyName} & TruckerCloud` : 'TruckerCloud'
        }'s `,
      linkText: 'Terms & Conditions',
      suffix: '',
    },
    fr: {
      prefix: 'En donnant votre autorisation, vous acceptez les ',
      linkText: 'conditions générales',
      suffix: (invitingCompanyName?: string | null) =>
        invitingCompanyName
          ? ` de ${invitingCompanyName} et de TruckerCloud.`
          : ' de TruckerCloud.',
    },
  },
} as const

export function biInline(en: string, fr: string): string {
  return isFrenchWidgetStringsEnabled ? `${en} / ${fr}` : en
}

export function biInlineLookup(enFromDB: string): string {
  if (!isFrenchWidgetStringsEnabled) return enFromDB
  const fr = FORM_LABEL_FR[enFromDB]
  return fr ? `${enFromDB} / ${fr}` : enFromDB
}

export function BiStacked(props: {
  en: React.ReactNode
  fr: React.ReactNode
}): JSX.Element {
  if (!isFrenchWidgetStringsEnabled) return <>{props.en}</>
  return (
    <>
      <div style={{ lineHeight: 1.65 }}>{props.en}</div>
      <div style={{ lineHeight: 1.65 }}>{props.fr}</div>
    </>
  )
}
